import { api } from "@/lib/axios"
import type { Order, OrdersResponse, OrderDetailResponse, UpdateOrderPayload, CreateOrderPayload } from "@/types/orders"

export async function fetchOrders(): Promise<Order[]> {
  const { data } = await api.get<OrdersResponse>("/orders/")
  return data.data
}

export async function fetchOrderDetail(id: number): Promise<Order> {
  const { data } = await api.get<OrderDetailResponse>(`/orders/${id}/`)
  return data.data
}

export async function updateOrder(id: number, payload: UpdateOrderPayload): Promise<Order> {
  const { data } = await api.patch<OrderDetailResponse>(`/orders/${id}/`, payload)
  return data.data
}

export async function deleteOrder(id: number): Promise<void> {
  await api.delete(`/orders/${id}/`)
}

export async function createOrder(payload: CreateOrderPayload): Promise<Order> {
  const { data } = await api.post<OrderDetailResponse>("/orders/", payload)
  return data.data
}
